import validate from "/usr/src/app/content/n3-spas-dad49042-d67b-4d55-b364-ef84e11bc198/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-dad49042-d67b-4d55-b364-ef84e11bc198/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}